import { createContext, useContext, useState, ReactNode } from "react";

interface DropdownContextType {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const DropdownContext = createContext<DropdownContextType | null>(null);

export const Dropdown = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);

  return (
    <DropdownContext.Provider value={{ open, setOpen }}>
      <div style={{ position: "relative", display: "inline-block" }}>{children}</div>
    </DropdownContext.Provider>
  );
};

export const DropdownTrigger = ({ children }: { children: ReactNode }) => {
  const context = useContext(DropdownContext);
  if (!context) throw new Error("DropdownTrigger must be used within Dropdown");

  return <div onClick={() => context.setOpen(!context.open)}>{children}</div>;
};

export const DropdownContent = ({ children }: { children: ReactNode }) => {
  const context = useContext(DropdownContext);
  if (!context) throw new Error("DropdownContent must be used within Dropdown");

  if (!context.open) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: 6,
        marginTop: 8,
        minWidth: 180,
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        zIndex: 1000,
      }}
    >
      {children}
    </div>
  );
};

export const DropdownItem = ({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: () => void;
}) => {
  const context = useContext(DropdownContext);
  if (!context) throw new Error("DropdownItem must be used within Dropdown");

  return (
    <div
      onClick={() => {
        onClick?.();
        context.setOpen(false); // close after select
      }}
      style={{
        padding: "10px 12px",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
    >
      {children}
    </div>
  );
};
